import { useMemo } from "react";

import { defineMessage, useIntl } from "react-intl";

import { ProductKeyTypes } from "@/libraries/wpl/foundations/src";

import { MobileNavCardProps } from "./mobile-nav-card";
import { MobileNavMenuPage } from "./mobile-nav-menu-page";

export const MobileNavProductITProfessionals = ({
    productKey = "home"
}: {
    productKey?: ProductKeyTypes;
}) => {
    const intl = useIntl();

    function useProductsData(): Array<MobileNavCardProps> {
        return useMemo(() => {
            const productData: Array<MobileNavCardProps> = [
                {
                    key: "jsm",
                    logo: "jiraservicemanagement",
                    href: "/software/jira/service-management",
                    name: "Jira Service Management",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.jsm.description",
                            defaultMessage: "High-velocity service delivery"
                        })
                    ),
                    isNew: false
                },
                {
                    key: "guard",
                    logo: "guard",
                    href: "/software/access",
                    name: "Guard",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.guard.description",
                            defaultMessage: "Enhanced cloud security"
                        })
                    ),
                    isNew: true
                }
            ];
            return productData;
        }, []);
    }

    const productsData = useProductsData();

    return (
        <MobileNavMenuPage
            pageLabel={intl.formatMessage({
                id: "globalnav.v2.productsitprofessionals.title",
                defaultMessage: "Product for IT Professionals"
            })}
            cards={productsData}
            productKey={productKey}
        />
    );
};
